import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { UsersAPI } from "../../../../api/users.api";
import { environment } from "../../../../environments/environment";
import { SessionStorageService } from "../../../../services/session-storage.service";

@Component({
  selector: "nb-login",
  styleUrls: ["./login.component.scss"],
  templateUrl: "login.component.html",
})
export class LoginComponent implements OnInit {
  public showMessages: any = {};
  public errors: string[] = [];
  public user: any = {};
  public submitted: boolean = false;
  public logo: string;

  constructor(
    protected router: Router,
    private route: ActivatedRoute,
    protected usersAPI: UsersAPI,
    private session: SessionStorageService
  ) {}

  async ngOnInit() {
    this.logo = environment.logo;
    // location.reload();
    this.session.clear();
    //retira os parametros da url
    let isInvited: string = this.route.snapshot.params["invited"];
    if (isInvited) {
      let user = isInvited.slice(0, 32);
      let pass = isInvited.slice(32, 64);
      let invitationUser = isInvited.substr(64);
      this.searchInvitatedUser(user, pass, invitationUser);
    }
  }

  login(form): void {
    this.session.clear();
    this.errors = [];
    this.submitted = true;
    if (form.valid) {
      this.usersAPI
        .login(this.user)
        .then((login) => {
          if (login) {
            this.session.setToken(login.Token);
            this.session.setUserId(login.UserId);
            this.session.setUserName(login.Name);
            this.session.setUserGroup(login.Group);
            this.session.setUserGroupId(login.GroupId);
            this.session.setEmail(login.Email);
            this.session.setCpf(login.Cpf);
            this.session.setContactLink(login.ContactLink);
            this.router.navigateByUrl("pages");
          }
        })
        .catch((error) => {
          this.showMessages.error = true;
          this.errors.push("E-mail ou senha inválidos");
          this.submitted = false;
        });
    } else {
      this.submitted = false;
    }
  }
  async searchInvitatedUser(user, pass, invitationUser) {
    let data = { md5User: user, md5Pass: pass, invitationUser: invitationUser };
    await this.usersAPI
      .validadeHash(data)
      .then((login) => {
        this.session.setToken(login.Token);
        this.session.setUserId(login.UserId);
        this.session.setUserName(login.Name);
        // this.session.setUserGroup(login.Group);
        this.session.setUserGroupId(login.GroupId);
        this.session.setEmail(login.Email);
        this.session.setContactLink(login.ContactLink);

        this.router.navigateByUrl("pages");
      })
      .catch((err) => {
        console.log(err);
        this.showMessages.error = true;
        this.errors.push("Link invalido !");
      });
    // let statusId = this.route.snapshot.params['statusId'] || 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/components/login/login.component.ts